import {
  post, get, patch, destroy,
} from './index';

/**
   * Send request to create a new season
   * @param {object} data season data
   * @param {number} orgId organization id
   * @returns Promise with http response
   */
export const createSeason = (data, orgId) => post(`/api/v1/seasons?organization_id=${orgId}`, data);

/**
   * Send request to get a seasons
   * @param {number} orgId organization id
   * @param {object} params api params for searching by name, start and end date
   * @returns Promise with http response regarding getting seasons
   */
export const getSeasons = (orgId, params) => {
  const data = params
    ? {
      sort_by: params.sortBy,
      direction: params.direction,
      organization_id: orgId,
      limit: params.limit,
      offset: params.offset,
    }
    : { organization_id: orgId };
  const queryParamString = new URLSearchParams(data).toString();

  return get(`/api/v1/seasons?${queryParamString}`);
};

/**
   * Send request to update a season
   * @param {*} data new season data
   * @param {*} orgId organization id
   * @param {*} seasonId season id
   * @returns Promise with http response regarding editing a season
   */
export const updateSeason = (data, orgId, seasonId) => patch(`/api/v1/seasons/${seasonId}?organization_id=${orgId}`, data);

/**
   * Send request to remove a season
   * @param {*} seasonId season id
   * @param {*} orgId organization id
   * @returns Promise with http response regarding removing a season
   */
export const removeSeason = (seasonId, orgId) => destroy(`/api/v1/seasons/${seasonId}?organization_id=${orgId}`);

/**
   * Send request to get a single season
   * @param {number} orgId organization id
   * @param {number} seasonId season id
   * @returns Promise with http response regarding single season
   */
export const getSeason = (orgId, seasonId) => get(`/api/v1/seasons/${seasonId}?organization_id=${orgId}`);
